import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";

import { CommunityEditorComponent } from "./community-editor.component";
import { EditableCommunityResolver } from "../../../shared/services";
import { AuthGuard } from "../../../shared";

const routes: Routes = [
  {
    path: "", // path is "editor"
    component: CommunityEditorComponent,
    canActivate: [AuthGuard],
    data: {
      title: "Community Creator",
      icon: "ti-layout-sidebar-left",
      caption: "Create your new community here",
      status: true,
    },
  },
  {
    path: ":communityName",
    component: CommunityEditorComponent,
    canActivate: [AuthGuard],
    resolve: {
      community: EditableCommunityResolver,
    },
    data: {
      title: "Community Editor",
      icon: "ti-layout-sidebar-left",
      caption: "Edit your community here",
      status: true,
    },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CommunityEditorRoutingModule {}
